import { render, staticRenderFns } from "./VendorForm.vue?vue&type=template&id=55aac345&scoped=true&"
import script from "./VendorForm.vue?vue&type=script&lang=js&"
export * from "./VendorForm.vue?vue&type=script&lang=js&"
import style0 from "./VendorForm.vue?vue&type=style&index=0&id=55aac345&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aac345",
  null
  
)

export default component.exports